import {useUserStore} from 'src/features/user/store.ts'
import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from 'src/queryClient.ts'
import {makeHttpAuthorizationHeader, parseAxiosPromise, raise} from 'src/helpers/helpers.ts'
import {httpGetHostApprovalAccessibilityTypes} from 'src/features/admin-host-approval/services/adminHostApproval.http.ts'
import {z} from 'zod'
import {captureException} from '@sentry/react'
import {AccessibilityType} from 'src/features/admin-host-approval/types.ts'

export const useHostApprovalAccessibilityTypes = () => {
    const adminAccessToken = useUserStore(store => store.adminAccessToken) ?? raise('adminAccessToken is nullish')

    return useQuery({
        queryKey: [QUERY_KEYS.ADMIN_HOST_APPROVAL_TASK_TYPES],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGetHostApprovalAccessibilityTypes({
                    headers: makeHttpAuthorizationHeader(adminAccessToken)
                }),
                responseShape: z.array(AccessibilityType),
                onZodError: captureException
            })
    })
}
